(function () {
	var gridEl = document.querySelector('.product-grid[data-batch][data-slot][data-cols][data-desired-col]');
	var BATCH = gridEl ? parseInt(gridEl.getAttribute('data-batch'), 10) : 24;
	var SLOT = gridEl ? parseInt(gridEl.getAttribute('data-slot'), 10) : 5;
	var COLS = gridEl ? parseInt(gridEl.getAttribute('data-cols'), 10) : 4;
	var DESIRED_COL = gridEl ? parseInt(gridEl.getAttribute('data-desired-col'), 10) : 2;

  var TILE_SELECTOR = ".post-pl:not(.collection-card-wrapper)";
  var BANNER_SELECTOR = ".collection-card-wrapper";
  var TEMPLATE_ID = "collection-card-template";
  var GRID_SELECTOR = ".product-grid, .collection-grid, .grid"; // adjust to your grid

  function grid() {
    return document.querySelector(GRID_SELECTOR) || document;
  }
  function tiles(g) {
    return Array.prototype.slice.call(g.querySelectorAll(TILE_SELECTOR));
  }
  function bannerForGroupExists(g, groupIndex) {
    return !!g.querySelector(BANNER_SELECTOR + '[data-banner-group="' + groupIndex + '"]');
  }
  function cloneBanner(groupIndex) {
    var tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl) return null;
    var content = tpl.content || tpl; // <template> support
    var proto = content.querySelector(BANNER_SELECTOR);
    if (!proto) return null;
    var c = proto.cloneNode(true);
    c.setAttribute("data-banner-group", String(groupIndex));
    return c;
  }

  function placeBanners() {
    var g = grid();
    if (!g) return;

    var items = tiles(g);
    if (!items.length) return;

    // How many banners are already in DOM (earlier groups)?
    var insertedCount = g.querySelectorAll(BANNER_SELECTOR).length;

    // Loop per batch using the product tiles list (excludes banners)
    var totalBatches = Math.ceil(items.length / BATCH);
    for (var groupIndex = 0; groupIndex < totalBatches; groupIndex++) {
      if (bannerForGroupExists(g, groupIndex)) continue;

      var start = groupIndex * BATCH;
      var end = Math.min(start + BATCH - 1, items.length - 1);

      // Nominal target: before the 5th product in this batch
      var baseIndex = start + (SLOT - 1);
      if (baseIndex > end) baseIndex = end;

      // Compute current column if we insert BEFORE items[baseIndex]
      // Column is based on TOTAL items before that point in the grid:
      // = product tiles before (baseIndex) + banners already inserted
      var totalBefore = baseIndex + insertedCount; // 0-based count of nodes before
      var currentCol = (totalBefore % COLS) + 1; // 1..COLS

      // Offset baseIndex so final banner sits in DESIRED_COL
      var offset = (DESIRED_COL - currentCol + COLS) % COLS; // 0..3
      var targetIndex = baseIndex + offset;

      // Keep target inside this batch
      if (targetIndex > end) {
        targetIndex -= COLS; // move one row up
        if (targetIndex < start) targetIndex = Math.min(baseIndex, end);
      }

      var banner = cloneBanner(groupIndex);
      if (!banner) continue;

      var target = items[targetIndex];
      if (target && target.parentNode) {
        target.parentNode.insertBefore(banner, target);
        insertedCount++; // We just added one more banner; affects next groups
      }
    }
  }

  function boot() {
    placeBanners();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Re-run after infinite scroll appends
  document.addEventListener("on:infinite-scroll:append", function () {
    placeBanners();
  });
})();
